import { createContext, useContext } from 'react';
import { storageKey } from '../config';
import type { Culture } from './cultures';

/** Where the picked culture is kept, under the app's storage prefix. */
export const cultureStorageKey = (): string => storageKey('culture');

export interface LanguageContextValue {
  culture: Culture;
  setCulture: (culture: Culture) => void;
}

export const LanguageContext = createContext<LanguageContextValue>({
  culture: 'en-GB',
  setCulture: () => undefined
});

export const useLanguage = (): LanguageContextValue => useContext(LanguageContext);
